import { isSupportedCountry, type CountryCode } from "libphonenumber-js";

export const DEFAULT_PHONE_COUNTRY: CountryCode = "IN";

const COUNTRY_NAME_TO_PHONE_CODE: Record<string, CountryCode> = {
  india: "IN",
  "united states": "US",
  "united states of america": "US",
  usa: "US",
  japan: "JP",
};

export const resolvePhoneCountryCode = (
  isoCode?: string,
  countryName?: string,
): CountryCode => {
  const normalizedCode = isoCode?.trim().toUpperCase();

  if (normalizedCode && isSupportedCountry(normalizedCode)) {
    return normalizedCode;
  }

  const normalizedName = countryName?.trim().toLowerCase();

  if (normalizedName && COUNTRY_NAME_TO_PHONE_CODE[normalizedName]) {
    return COUNTRY_NAME_TO_PHONE_CODE[normalizedName];
  }

  return DEFAULT_PHONE_COUNTRY;
};
